import { useAutoneTranslation } from '@autone/translations';
import { forwardRef } from 'react';

import { Button, type ButtonProps, cn } from '../../../../../../tailwind';
import { useChangeFiltersPopoverViewContext } from '../../../ChangeFiltersPopoverView.context';

export const CloseSavedFiltersButton = forwardRef<
  HTMLButtonElement,
  ButtonProps
>(({ className, ...props }, ref) => {
  const { common } = useAutoneTranslation();
  const [, dispatch] = useChangeFiltersPopoverViewContext();
  return (
    <Button
      variant="outlined"
      color="secondary"
      className={cn('h-8', className)}
      onClick={() => dispatch({ type: 'GO_BACK' })}
      {...props}
      ref={ref}
    >
      {common('filters.close-saved-filters')}
    </Button>
  );
});
